'use client'

import { FC } from 'react'

import { IAgencyCardProps } from './types'

const AgencyCard: FC<IAgencyCardProps> = ({ tenant, onClick, disabled }) => {
  return (
    <div
      className={`bg-white rounded-lg shadow-sm border p-4 transition-all border-grayscale-200
      ${
        disabled
          ? 'border-grayscale-200 shadow-md scale-100'
          : 'border-grayscale-200 hover:shadow-md hover:border-primary-500 cursor-pointer scale-[0.97] hover:scale-100 transition-all duration-300'
      }`}
      onClick={onClick && onClick}
    >
      <div className="flex flex-col gap-2">
        <h3 className="prose-body-large font-semibold text-grayscale-900">
          {tenant.tenantName}
        </h3>
        {tenant.statusName && (
          <p className="prose-body-small text-grayscale-600">
            {tenant.statusName}
          </p>
        )}
      </div>
    </div>
  )
}

export default AgencyCard
